import React, { useState } from 'react';
import { Select } from 'syngenta-digital-cropwise-react-ui-kit';
import PropTypes from 'prop-types';

import ChevronDown from 'assets/chevron_down.svg?react';
import ChangeSumaryFFT from '../ChangeSummaryFFT';
import './index.css';

const VIEW_BY = [
  {
    value: 'crops',
    label: 'Crops'
  },
  {
    value: 'farm',
    label: 'Farm'
  }
];

const selectedFieldsDefaultPropMassiveChangeSummary = {};
const SelectedFields = ({
  massiveChangeSummary = selectedFieldsDefaultPropMassiveChangeSummary
}) => {
  const [viewBy, setViewBy] = useState('farm');

  return (
    <div
      data-testid="selected-fields-summary"
      className="flex flex-col"
      style={{ height: 'calc(100% - 1px)' }}
    >
      <div className="sticky top-9 bg-white z-1 pt-2">
        <label
          htmlFor="viewBy"
          className="text-neutral-600 text-sm inline-block"
        >
          View By
        </label>
        <Select
          id="viewBy"
          className="w-full"
          placeholder="View By"
          options={VIEW_BY}
          value={viewBy}
          onChange={setViewBy}
          suffixIcon={<ChevronDown width={18} height={18} aria-hidden="true" />}
        />
      </div>
      <div className="mt-4 overflow-y-auto overflow-x-hidden h-full flex grow selected-fields-scroll">
        <ChangeSumaryFFT
          massiveChangeSummary={massiveChangeSummary}
          viewBy={viewBy}
        />
      </div>
    </div>
  );
};

SelectedFields.propTypes = {
  massiveChangeSummary: PropTypes.shape()
};

export default SelectedFields;
